import type { PropsWithChildren } from 'react';

const GridWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div
      className="suggestion-grid flex h-fit max-h-100 grow flex-col"
      data-testid="suggestion-entity-grid"
    >
      {children}
    </div>
  );
};

export default GridWrapper;
